import { addClass, css, removeClass } from "../utils/CssUtils";
import { addEventListener } from '../utils/EventUtils';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import AbstractComponent from './AbstractComponent';
import anime from "animejs";
import Logger from '../utils/Logger';

export default class SiteMenu extends AbstractComponent {
    constructor(...args) {
        Logger.log('SiteMenu->constructor()');
        super(...args);

        this.classname = 'c-site-menu';
        this.isBurgerOpen = false;
        this.backgroundBottomPadding = 57;
        this.mobileBottomPadding = 32;
        this.backgroundIsShowClass = this.getClassname('__background--is-shown');
        this.initDomElements();
        this.addEventListeners();
    }

    initDomElements() {
        this.$burger = this.$el.querySelector(this.getSelector('__burger'));
        this.$background = this.$el.querySelector(this.getSelector('__background'));
        this.$pagesSubmenus = this.$el.querySelectorAll(this.getSelector('__pages__item--submenu'));
        this.$langs = this.$el.querySelector(this.getSelector('__langs-container'));
    }

    addEventListeners() {
        if (this.$burger) {
            addEventListener(this.$burger, 'click', this.toggleBurger.bind(this));
        }

        if (this.$background && this.$pagesSubmenus) {
            this.$pagesSubmenus.forEach((submenu) => {
                addEventListener(submenu, 'mouseover', () => this.submenuMouseHoverListener(submenu));
                addEventListener(submenu, 'mouseout', () => this.submenuMouseOutListener(submenu));
            });
        }

        this.app.on('resize', this.resizeListener.bind(this));
        this.app.on('breakpoint-update', this.handleBodyScroll.bind(this));
    }

    toggleBurger() {
        this.$burger.blur();
        this.isBurgerOpen = !this.isBurgerOpen;
        if (!this.isBurgerOpen) {
            this.closeBurger();
        } else {
            this.openBurger();
        }
        this.handleBodyScroll();
    }

    openBurger() {
        const isOpenClass = this.getClassname('--is-open');
        addClass(this.$el, isOpenClass);
        this.openBurgerSetBackgroundHeight();
        this.openBurgerSetLangsTop();
        anime({
            targets: [document.documentElement, document.body],
            scrollTop: 0,
            duration: 300,
            easing: 'easeOutQuad'
        });
    }

    getTallestSubmenuBottom() {
        const scrollY = window.pageYOffset || document.documentElement.scrollTop;
        let tallestSubmenuBottom = 0;
        if (this.$pagesSubmenus) {
            this.$pagesSubmenus.forEach((submenu) => {
                const submenuElement = submenu.querySelector(this.getSelector('__pages__submenu'));
                if (!submenuElement) {
                    return;
                }
                const submenuElementBottom = scrollY + submenuElement.getBoundingClientRect().bottom;
                tallestSubmenuBottom = Math.max(tallestSubmenuBottom, submenuElementBottom);
            });
        }
        return tallestSubmenuBottom;
    }

    openBurgerSetBackgroundHeight() {
        let backgroundHeight = 0;
        if (this.app.isBreakpointUp('md')) {
            if (this.$pagesSubmenus) {
                let tallestSubmenuBottom = this.getTallestSubmenuBottom();
                backgroundHeight = tallestSubmenuBottom + this.backgroundBottomPadding;
            } else {
                const burgerBounds = this.$burger.getBoundingClientRect();
                backgroundHeight = (2 * burgerBounds.top) + burgerBounds.height;
            }
            css(this.$background, { 'height': backgroundHeight + 'px' });
        } else {
            css(this.$background, { 'height': '120vh' });
        }
    }

    openBurgerSetLangsTop() {
        if (!this.$langs) {
            return;
        }
        if (this.app.isBreakpointUp('md')) {
            let top = 0;
            if (this.$pagesSubmenus) {
                const langsBounds = this.$langs.getBoundingClientRect();
                top = this.getTallestSubmenuBottom() - langsBounds.height;
            } else {
                top = 12;
            }
            css(this.$langs, { 'top': top + 'px' });
            css(this.$langs, { 'bottom': null });
        } else {
            css(this.$langs, { 'top': null });
            css(this.$langs, { 'bottom': this.mobileBottomPadding + 'px' });
        }
    }

    closeBurger() {
        const isOpenClass = this.getClassname('--is-open');
        removeClass(this.$el, isOpenClass);
        css(this.$background, { 'height': null });
    }

    handleBodyScroll() {
        if (this.app.isBreakpointUp('md')) {
            enableBodyScroll(this.$el);
        } else {
            if (this.isBurgerOpen) {
                disableBodyScroll(this.$el);
            } else {
                enableBodyScroll(this.$el);
            }
        }
    }

    submenuMouseHoverListener(submenu) {
        if (this.isBurgerOpen) { return; }
        const submenuElement = submenu.querySelector(this.getSelector('__pages__submenu'));
        if (!submenuElement) {
            return;
        }
        const scrollY = window.pageYOffset || document.documentElement.scrollTop;
        const backgroundHeight = scrollY + submenuElement.getBoundingClientRect().bottom + this.backgroundBottomPadding;
        addClass(this.$background, this.backgroundIsShowClass);
        css(this.$background, { 'height': backgroundHeight + 'px' });
    }

    submenuMouseOutListener(submenu) {
        if (this.isBurgerOpen) { return; }
        removeClass(this.$background, this.backgroundIsShowClass);
        css(this.$background, { 'height': null });
    }

    resizeListener() {
        this.openBurgerSetBackgroundHeight();
        this.openBurgerSetLangsTop();
    }

    destroy() { }
}